const footer = require(`./${process.env.REACT_APP_STYLE}`).default;

export default footer;
